"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const common_1 = require("@components/common");
const CategoryHalfDonuts_1 = __importDefault(require("./Charts/CategoryHalfDonuts"));
const CategoryColumns_1 = __importDefault(require("./Charts/CategoryColumns"));
const ModulesRound_1 = __importDefault(require("./Charts/ModulesRound"));
const ModulesColumns_1 = __importDefault(require("./Charts/ModulesColumns"));
const MinutesColumns_1 = __importDefault(require("./Charts/MinutesColumns"));
const TargetLines_1 = __importDefault(require("./Charts/TargetLines"));
const ErrosTeble_1 = __importDefault(require("./Charts/ErrosTeble"));
const ChartsDateFilter_1 = require("@app/routes/Dashboard/components/ChartsDateFilter");
const TargetExerciseContext_1 = require("@app/routes/Dashboard/components/TargetExerciseContext");
const Dashboard = () => (react_1.default.createElement(ChartsDateFilter_1.ChartsDateFilterContextProvider, null,
    react_1.default.createElement(TargetExerciseContext_1.TargetExerciseContextProvider, null,
        react_1.default.createElement(common_1.Box, { w: "100%", className: 'dashboard-container' },
            react_1.default.createElement(CategoryHalfDonuts_1.default, null),
            react_1.default.createElement(ChartsDateFilter_1.ChartsDateFilter, null),
            react_1.default.createElement(CategoryColumns_1.default, null),
            react_1.default.createElement(common_1.Flex, { justify: "space-between" },
                react_1.default.createElement(ModulesRound_1.default, null),
                react_1.default.createElement(ModulesColumns_1.default, null)),
            react_1.default.createElement(common_1.Flex, { justify: "space-between" },
                react_1.default.createElement(MinutesColumns_1.default, null),
                react_1.default.createElement(TargetLines_1.default, null)),
            react_1.default.createElement(ErrosTeble_1.default, null)))));
exports.default = Dashboard;
